export default class PreferenceMappingModel {
  preferenceId: string = "";
}
